import type {
  ComponentProps,
  ReactNode,
} from "react"

import { Page } from "./Page"
import { PageHeader } from "./PageHeader"

interface Props extends ComponentProps<typeof PageHeader> {
  title?: ComponentProps<typeof PageHeader>["children"];
  children?: ReactNode;
}

export function PageTemplate(props: Props) {
  const {
    title,
    children,
    ...headerProps
  } = props

  return (
    <>
      <PageHeader {...headerProps}>
        {title}
      </PageHeader>
      <Page>
        {children}
      </Page>
    </>
  )
}
